export default {
  // baseURL: '//duocodes.com/axcelerate/',
  baseURL: '//healthcorp.com.au/axcelerate/',
  verify: function(certID) {
    return this.baseURL + 'verify/' + certID;
  },

}
